import {
  Typography,
  Box,
  Button,
  Avatar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
import FeatureComponents from "./components/featureComponents";
import { useTranslation } from "react-i18next";

const DashboardPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ p: { xs: 2, md: 4 }, mt: 6 }}>
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 4,
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          <Avatar
            alt="Djoglo Logo"
            sx={{
              width: 70,
              height: 70,
              bgcolor: "primary.main",
            }}
            variant="rounded"
          >
            <DashboardIcon fontSize="large" />
          </Avatar>
          <Box>
            <Typography
              variant={isMobile ? "h4" : "h3"}
              component="h1"
              sx={{
                fontWeight: 800,
                background: "linear-gradient(45deg, #1976d2 30%, #4dabf5 90%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                lineHeight: 1.2,
              }}
            >
              {t("Dashboard.dashboardTitle")}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
            >
              {t("Dashboard.dashboardSubtitle")}
            </Typography>
          </Box>
        </Box>

        {/* Features Section */}
        <FeatureComponents />
      </Box>
      {/* Quick Access */}
      <Box
        sx={{
          textAlign: "center",
          p: { xs: 3, sm: 4 },
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)",
          borderRadius: 3,
          width: "100%",
          mx: 0,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          {t("Dashboard.quickHelpTitle")}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            maxWidth: "600px",
            mx: "auto",
            mb: 3,
            px: { xs: 1, sm: 0 },
          }}
        >
          {t("Dashboard.quickHelpDescription")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              const mailtoLink =
                "mailto:support@joglo.ink?subject=Bantuan Cepat&body=Halo Tim Support,%0A%0ASaya butuh bantuan dengan...";
              window.open(mailtoLink, "_blank");
            }}
            sx={{
              fontWeight: 600,
              px: 4,
              borderRadius: 2,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {t("Dashboard.contactSupport")}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default DashboardPage;
